import { Product } from 'BrokerTsLib/src/enums'
import { ContractsExportForm, ContractsCarExportFormValues } from './ContractsExportForm'

export const ContractsCarExport = () => {
  return (
    <ContractsExportForm product={Product.VehicleInsurance} />
  )
}
